export default "__VITE_ASSET__$f4nuwTE__"